import { render, staticRenderFns } from "./shareTip.vue?vue&type=template&id=700abed6&scoped=true"
import script from "./shareTip.vue?vue&type=script&lang=js"
export * from "./shareTip.vue?vue&type=script&lang=js"
import style0 from "./shareTip.vue?vue&type=style&index=0&id=700abed6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700abed6",
  null
  
)

export default component.exports